import React, {Component}   from 'react';
import {
  Panel,
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel
}                           from 'react-bootstrap';
import Pagination           from "react-js-pagination";
import _                    from 'lodash';
import moment               from 'moment';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

import Table                from './Table';
import Modal                from './Modal';
import View                 from './View';

import {AUDIT_TRAIL}         from '../../actions/const';

class AuditTrail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activePage: 1,
      isLoading: false,
      isExporting: false,
      showModal: false,
      selectedData: null
    };

    this.stateSetter = this.stateSetter.bind(this);
    this.handlePaginate = this.handlePaginate.bind(this);
    this.getAuditTrails = this.getAuditTrails.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  stateSetter(stateArray) {
    for (var i in stateArray) {
      this.setState({ [stateArray[i].state]: stateArray[i].value }, () => {
        if (stateArray[i].state === 'filterUser') {
          this.getAccessList();
        }
      });
    }
  }

  handlePaginate(pageNumber) {
    this.setState({ activePage: pageNumber }, () => {
      this.getAuditTrails();
    });
  }

  loadOptions(input, cb, className, columnName) {
    var query = new Parse.Query(className);
    if (className === 'User') {
      query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
    } else if (className === 'ModulesWeb') {
      var appsQuery = new Parse.Query('Apps');
      appsQuery.equalTo('name', 'RWM CMS');

      query.matches(columnName, input, 'i');
      query.matchesQuery('Apps', appsQuery);
    } else if (className === 'Actions') {
      query.matches(columnName, input, 'i');
    }

    query.limit(20);
    query.find()
    .then((data) => {
      return data.map((item) => item = {
        label: item.get(columnName),
        value: item.id
      });
    })
    .then((data) => {
			cb(null, {options: data});
		})
    .catch((err) => {
      console.log('loadOptions error: ', err.message);
    })
  }

  getAuditTrails() {
    this.setState({ isLoading: true });
    let {
      activePage
    } = this.state;

    let {
      setValue
    } = this.props.actions;

    let {
      limit,
      filterUser,
      filterModule,
      filterAction,
      filterStartDate,
      filterEndDate
    } = this.props.auditTrail;

    const isNull = (obj) => obj == null
      ? true
      : false;

    const getValue = (obj) => isNull(obj)
      ? ''
      : obj.value;

    var auditTrailQuery = new Parse.Query('AuditTrailsWeb');

    var appsQuery = new Parse.Query('Apps');
    appsQuery.equalTo('name', 'RWM CMS');

    var accessListQuery = new Parse.Query('AccessListWeb');
    accessListQuery.matchesQuery('Apps', appsQuery);

    if (getValue(filterUser) !== '') {
      var User = Parse.Object.extend(Parse.User),
          user = new User();
      user.id = getValue(filterUser);
      auditTrailQuery.equalTo('User', user);
    }

    if (getValue(filterModule) !== '') {
      var Module = Parse.Object.extend('ModulesWeb'),
          module = new Module();
      module.id = getValue(filterModule);

      accessListQuery.equalTo('ModulesWeb', module);
    }

    if (getValue(filterAction) !== '') {
      var Actions = Parse.Object.extend("Actions");
      var actions = new Actions();
      actions.id = getValue(filterAction);

      accessListQuery.equalTo('Actions', actions);
    }

    if (filterStartDate !== '' && filterEndDate !== '') {
      var start = moment(filterStartDate).startOf('day').toDate();
      var end = moment(filterEndDate).endOf('day').toDate();

      auditTrailQuery.greaterThanOrEqualTo('createdAt', start);
      auditTrailQuery.lessThanOrEqualTo('createdAt', end);
    }

    auditTrailQuery.matchesQuery('AccessListWeb', accessListQuery);
    auditTrailQuery.limit(limit);
    auditTrailQuery.skip((activePage -1) * limit);
    auditTrailQuery.descending("createdAt");
    auditTrailQuery.include(['User', 'AccessListWeb.ModulesWeb', 'AccessListWeb.Actions', 'AccessListWeb.Apps']);

    var qCount = _.clone(auditTrailQuery);
    qCount.skip(0);
    qCount.limit(-1);

    Promise.all([auditTrailQuery.find(), qCount.count()])
    .then((data) => {
      setValue(AUDIT_TRAIL, 'tableData', data[0]);
      setValue(AUDIT_TRAIL, 'totalRecord', data[1]);
      this.setState({ isLoading: false });
    })
    .catch((err) => {
      console.log('getAuditTrails error: ', err.message);
      this.setState({ isLoading: false });
    });
  }

  componentWillMount() {
    // let {
    //   setValue
    // } = this.props.actions;
    //
    // var url = window.location.href.toUpperCase();
    // setValue(AUDIT_TRAIL, 'mode', (url.indexOf('AUDITTRAILWEB') !== -1) ? 'AuditTrailsWeb' : 'AuditTrailsApp');
  }

  accessible(actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

  render() {
    let {
      activePage,
      isLoading,
      isExporting,
      showModal,
      selectedData
    } = this.state;

    let {
      mode,
      limit,
      totalRecord,
      tableData,
      filterUser,
      filterModule,
      filterAction,
      filterStartDate,
      filterEndDate
    } = this.props.auditTrail;

    let {
      setValue
    } = this.props.actions;

    let paginationProps = {
      activePage: activePage,
      itemsCountPerPage: limit,
      totalItemsCount: totalRecord,
      pageRangeDisplayed: 5,
      onChange: this.handlePaginate
    };

    let tableProps = {
      isLoading,
      loadOptions: this.loadOptions,
      stateSetter: this.stateSetter,
      getAuditTrails: this.getAuditTrails,
      accessible: this.accessible
    };

    let modalProps = {
      showModal,
      stateSetter: this.stateSetter
    };

    return (
      <Panel>
				<Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
					<h4>Audit Trail</h4>
				</Panel.Heading>
				<Panel.Body>
          <Row>
            <Col md={3} >
              <Button className="btn btn-primary"
                disabled={(isExporting) ? 'disabled' : ''}
                style={{ display: this.accessible('EXPORT')}}
                onClick={() => (this.accessible('EXPORT') === '') ? {} : {}}
                >
                <span>
                  <i className="fa fa-spinner fa-spin" style={{display: ((isExporting) ? 'inline-block' : 'none')}}></i> {(isExporting) ? 'Exporting' : 'Export'}
                </span>
              </Button>
            </Col>
          </Row>
          <Table {...tableProps}/>
          <div>Total Records: {totalRecord}</div>
    			<Pagination {...paginationProps}/>
          <Modal {...modalProps}>
            <View selectedData={selectedData}/>
          </Modal>
				</Panel.Body>
			</Panel>
    );
  }

  componentDidMount() {
    let {
      setValue
    } = this.props.actions;
    // this.getAuditTrails();
  }
}

function mapStateToProps(state) {
	var {auditTrail, accessjson} = state;
	const props = {
		auditTrail,
    accessjson
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch)
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditTrail);



// WEBPACK FOOTER //
// ./components/AuditTrail/index.js